import React from 'react'

import {
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
} from '@mui/x-data-grid'

export default function CustomToolbar({
  isMobile,
}: {
  toggleExecuteModal: () => void
  toggleRemoveModal: () => void
  selectedTransactions: any[]
  onCheckTransactions: () => void
  isMobile: boolean
}) {
  return (
    <GridToolbarContainer
      sx={{
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
      }}>
      <GridToolbarColumnsButton
        sx={{
          color: 'white',
          fontFamily: 'SpaceGrotesk, sans-serif',
        }}
      />
      <GridToolbarFilterButton
        sx={{
          color: 'white',
          fontFamily: 'SpaceGrotesk, sans-serif',
        }}
      />
      <GridToolbarDensitySelector
        sx={{
          color: 'white',
          fontFamily: 'SpaceGrotesk, sans-serif',
        }}
      />
    </GridToolbarContainer>
  )
}
